module.exports = __webpack_public_path__ + "img/icon8.746a1e09.svg";